import dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import {
  cloneMap,
  DataModel,
  DataModelBuilder,
  isSameMap,
  mapToData,
  SerializationContext,
  SerializedData,
} from '../dto/dto.js';

export class LocationHistory extends DataModel {
  static readonly TYPE_ID: string = '64bffd43efc941d39538315ef1a624df';

  constructor(
    public readonly history: Map<string, dayjs.Dayjs>,
  ) {
    super();
  }

  get $typeId(): string {
    return LocationHistory.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocationHistory {
    return new LocationHistory(
        MapUtils.getMap(map, 'history', (k: string, v: unknown) => {
          return {
            key: k,
            value: context.decodeDate(v as number),
          };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'history': mapToData(this.history, (k: string, v: dayjs.Dayjs) => {
        return {
          key: k,
          value: context.encodeDate(v),
        };
      }),
    };
  }

  clone(): this {
    return new LocationHistory(
        cloneMap(this.history, (v: dayjs.Dayjs) => {
          return TimeZone.cloneDate(v);
        }),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameMap(other.history, this.history);
  }
}

export class LocationHistoryBuilder extends DataModelBuilder<LocationHistory> {
  build(context: SerializationContext, map: SerializedData): LocationHistory {
    return LocationHistory.fromMap(context, map);
  }
}
